/**
 * Enum to define which css code will be chosen when a document is printed
 */
export enum StyleEnum  {
  NONE,
  VISUALS,
  PRODUCTION_FILE,
  ORDER_PRODUCTS
}
